module.exports = __webpack_public_path__ + "img/metal_ab@2x.669b6cc6.png";